"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function interpole(source, params, options = { clearDirtyParam: false }) {
    if (typeof source !== 'string') {
        return source;
    }
    const { clearDirtyParam: needClearDirtyParam, ...otherOptions } = options;
    if (Array.isArray(params)) {
        source = (0, utils_1.replaceKeywordForArrayParams)(source, params, otherOptions);
    }
    else {
        source = (0, utils_1.replaceKeywordForObjectParams)(source, params, otherOptions);
    }
    if (needClearDirtyParam) {
        return (0, utils_1.clearDirtyParam)(source);
    }
    return source;
}
exports.default = interpole;
